export enum InfoLineStatus {
    SUCCESS = 'SUCCESS',
    WARNING = 'WARNING'
}

export interface InfoLine {
    status: InfoLineStatus
    label: string
}
